import OwnedUsersResponse from "@/api/Main/dataSource/api/projects/performers/i-service/model/response/OwnedUsersResponse";
import { EmployeeAccessModel, EmployeeModel } from "../models";
import GetEmployeesListResponse from "@/api/Main/dataSource/api/projects/performers/i-service/model/response/GetEmployeesListResponse";
import GetQueueTaskEmployeeListResponseItem from "@/api/Main/dataSource/api/projects/performers/i-service/model/queue-task/response/GetQueueTaskEmployeeListResponseItem";
import GetQueueTaskEmployeeListDetailResponse from "@/api/Main/dataSource/api/projects/performers/i-service/model/queue-task/response/GetQueueTaskEmployeeListDetailResponse";
import EmployeeQueueTaskAccessEnum from "@/api/Main/dataSource/api/projects/performers/enums/EmployeeQueueTaskAccessEnum";
import { EmployeeQueueAccessEnum } from "../enums";
import UpdateQueueTaskEmployeeRoleAccessListUserItem from "@/api/Main/dataSource/api/projects/performers/i-service/model/queue-task/request/UpdateQueueTaskEmployeeRoleAccessListUserItem";
import GetQueueTaskRemovedEmployeeListResponse from "@/api/Main/dataSource/api/projects/performers/i-service/model/queue-task/response/GetQueueTaskRemovedEmployeeListResponse";

export const mapGetOwnedUsersResponse = (
  response: GetQueueTaskRemovedEmployeeListResponse | OwnedUsersResponse,
) =>
  response.Items.map(
    (item) =>
      new EmployeeModel({
        Id: item.UserId,
        FirstName: item.FirstName,
        LastName: item.LastName,
        MiddleName: item.MiddleName,
        AvatarColor: item.AvatarColor,
        Foto: item.Photo || item.Foto,
        Status: item.Status,
      }),
  );

export const mapGetEmployeesResponse = (response: GetEmployeesListResponse) =>
  response.Items.map(
    (item) =>
      new EmployeeModel({
        Id: item.UserId,
        FirstName: item.FirstName,
        LastName: item.LastName,
        MiddleName: item.MiddleName,
        AvatarColor: item.AvatarColor,
        Foto: item.Foto,
      }),
  );

export const mapGetUsersAccessResponse = (response: GetQueueTaskEmployeeListDetailResponse) =>
  response.Items.map(
    (item) =>
      new EmployeeAccessModel({
        Id: item.UserId,
        FirstName: item.FirstName,
        LastName: item.LastName,
        MiddleName: item.MiddleName,
        AvatarColor: item.AvatarColor,
        Foto: item.Photo,
        Accesses: convertStatus(item.Accesses),
        Status: item.Status,
      }),
  );

export const mapUpdateUsersAccessResponse = (response: EmployeeAccessModel[]) =>
  response
    .map(
      (item) =>
        new UpdateQueueTaskEmployeeRoleAccessListUserItem({
          UserId: item.Id,
          Accesses: deConvertStatus(item.Accesses),
        }),
    )
    .filter((item) => item.Accesses.length > 0);

function convertStatus(value: Array<EmployeeQueueTaskAccessEnum>): boolean[] {
  return [
    value.includes(EmployeeQueueTaskAccessEnum.CreateTask),
    value.includes(EmployeeQueueTaskAccessEnum.UpdateOtherTask),
    value.includes(EmployeeQueueTaskAccessEnum.VisibilityOtherTask),
    value.includes(EmployeeQueueTaskAccessEnum.FinallyEstimate),
  ];
}
function deConvertStatus(value: boolean[]): Array<EmployeeQueueTaskAccessEnum> {
  const res = [];
  if (value[0]) res.push(EmployeeQueueTaskAccessEnum.CreateTask);
  if (value[1]) res.push(EmployeeQueueTaskAccessEnum.UpdateOtherTask);
  if (value[2]) res.push(EmployeeQueueTaskAccessEnum.VisibilityOtherTask);
  if (value[3]) res.push(EmployeeQueueTaskAccessEnum.FinallyEstimate);
  return res;
}
